import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingAnimation from './LoadingAnimation';
import Footer from './Footer';
import EventCard from './EventCard';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'events'), orderBy('date', 'asc')));
        const now = new Date();
        const upcoming = snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(e => {
            const status = e.status || 'published';
            if (status === 'deleted' || status === 'draft') return false;
            if (status === 'scheduled' && e.scheduled_at && e.scheduled_at.toDate() > now) return false;
            return e.date && e.date.toDate() >= now;
          });
        setEvents(upcoming);
      } catch (err) {
        console.error('Error fetching events:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  if (loading) return <div className="stt-page"><LoadingAnimation /></div>;

  return (
    <div className="stt-page">
      <div className="stt-content">
        <div className="stt-section">
          <h1 className="stt-page-title">Events</h1>
          <hr className="divider-gold" style={{ margin: '0 0 32px' }} />
          {events.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#888' }}>No upcoming events at this time. Check back soon!</p>
          ) : (
            events.map(event => <EventCard key={event.id} event={event} />)
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Events;
